import { AxiosResponse } from 'axios';
import {
  ContentTagIdListRequest,
  ExtensiveAttributeListResponse,
  ExtensiveAttributeModel,
  NotDataAuthorizationQuery,
  ContentTagServiceAccessPermissionQuery,
  UpdateUserExtensiveAttributeDefinitionsRequest,
  UserExtensiveAttributeDefinitionsRequest,
} from 'types/entity';
import { http } from './settings';

export const fetchExtensiveAttributeDefinitions = (projectId: string, notDataAuthorization: NotDataAuthorizationQuery, contentTagServiceAccessPermission: ContentTagServiceAccessPermissionQuery): Promise<ExtensiveAttributeModel[]> => http
  .get(`/projects/${projectId}/extensive-attribute-definitions`, { params: { 'not-data-authorization-flag': notDataAuthorization, content_tag_service_access_permission_flag: contentTagServiceAccessPermission } })
  .then((response: AxiosResponse<ExtensiveAttributeListResponse>) => response.data.content_tags || []);

export const postExtensiveAttributeDefinitions = (
  projectId: string,
  attributes: UserExtensiveAttributeDefinitionsRequest,
): Promise<ExtensiveAttributeModel> => http
  .post(`/projects/${projectId}/user-extensive-attribute-definitions`, attributes)
  .then((value: AxiosResponse<ExtensiveAttributeModel>) => value.data);

export const putExtensiveAttributeDefinitions = (
  projectId: string,
  extensiveAttributeDefinitionId: string,
  attributes: UpdateUserExtensiveAttributeDefinitionsRequest,
): Promise<ExtensiveAttributeModel> => http
  .put(`/projects/${projectId}/user-extensive-attribute-definitions/${extensiveAttributeDefinitionId}`, attributes)
  .then((value: AxiosResponse<ExtensiveAttributeModel>) => value.data);

/**
 * (007008) 拡張属性定義関連内容タグ一括更新
 */
export const putExtensiveAttributesAppliedContentTags = (
  projectId: string,
  extensiveAttributeDefinitionId: string,
  contentTagIdListRequest: ContentTagIdListRequest,
): Promise<string[]> => http
  .put(`/projects/${projectId}/extensive-attribute-definitions/${extensiveAttributeDefinitionId}/content-tags`, contentTagIdListRequest)
  .then((response: AxiosResponse<ContentTagIdListRequest>) => response.data.content_tag_id || []);
